import React from 'react';
import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';
import {
  TaxIdDTO,
} from 'dtos';

export default function TaxIdInfo(taxId: TaxIdDTO) {
  const { number, type } = taxId;
  return (
    <small className="flex items-center gap-2">
      {isEmpty(taxId)
        ? 'No Tax ID'
        : compact([type, number]).join(' • ')}
    </small>
  );
}
